module.exports = __webpack_public_path__ + "static/img/img_logo.1aeeb244.png";